import { createStore } from '@store/createStore';

const useWhatsNewStore = createStore(
  (set) => ({
    isFavorite: 0,
    actions: {
      setWhatsNewIsFavorite: (isFavorite) => set({ isFavorite }),
    },
  }),
  'WhatsNewStore',
);

export const useWhatsNewActions = () => useWhatsNewStore((state) => state.actions);

export const selectWhatsNewIsFavorite = () => useWhatsNewStore((state) => state.isFavorite);
